export const messages = {
  // ─── NotificationBell ───────────────────────────────────────────────
  bellLabel: 'Notifications',
  bellLabelUnread_one: 'Notifications ({{count}} unread)',
  bellLabelUnread_other: 'Notifications ({{count}} unread)',

  // ─── NotificationPanel ──────────────────────────────────────────────
  panelHeading: 'Notifications',
  preferencesButtonLabel: 'Notification preferences',
  closePanelLabel: 'Close notifications',
  desktopAlertsLabel: 'Get a desktop alert when something needs your attention',
  desktopAlertsCta: 'Enable desktop alerts',
  desktopAlertsBlocked: 'Desktop alerts are blocked. Unblock in site settings to re-enable.',
  pushAvailableLabel: 'Also receive alerts when this tab is closed',
  pushAvailableCta: 'Enable background push',
  pushSubscribedLabel: 'Background push is on. Alerts continue when the tab is closed.',
  pushDisableCta: 'Disable',
  pushElsewhereLabel: 'Push on this browser goes to another account or workspace.',
  pushElsewhereCta: 'Use it here',
  pushRefusedLabel: 'This browser\'s push service isn\'t supported here. In-tab alerts still work.',
  pushTakenLabel: 'This browser\'s push is linked to another account\'s device.',
  prefsNotSaved: 'Not saved yet. Your changes apply on this device and will be saved when the connection returns.',
  markAllRead: 'Mark all read',
  markTabRead: "Mark these read ({{count}})",
  archiveRead: "Archive read ({{count}})",
  refresh: 'Refresh',
  tabAll: 'All',
  tabUnread: 'Unread',
  tabArchived: 'Archived',
  emptyUnread: 'Nothing unread.',
  emptyArchived: 'Nothing archived.',
  emptyAll: 'No notifications yet. Run a workflow that needs an approval to see something here.',
  rowMarkRead: 'Mark read',
  rowMarkUnread: 'Mark unread',
  rowArchive: 'Archive',
  rowDelete: 'Delete',
  deleteConfirm: "Delete this notification? This can't be undone — use Archive to dismiss without deleting.",
  actionOpenInbox: 'Open inbox',
  actionViewRun: 'View run',
  actionReconnect: 'Reconnect',
  actionView: 'View',
  actionViewOrder: 'View order',
  actionViewPurchase: 'View purchase',
  actionViewCampaign: 'View campaign',
  actionViewComment: 'View comment',
  actionViewCard: 'View card',
  actionOpenChannel: 'Open channel',
  actionViewDeliverable: 'View document',
  actionViewBriefing: 'View briefing',
  relativeJustNow: 'just now',
  relativeMinutes: '{{count}}m ago',
  relativeHours: '{{count}}h ago',
  relativeDays: '{{count}}d ago',

  // ─── NotificationPreferencesPanel ───────────────────────────────────
  prefsBackLabel: 'Back to notifications',
  prefsBack: 'Back',
  prefsHeading: 'Preferences',
  prefsSectionGlobal: 'Global',
  prefsMuteAll: 'Mute all notifications',
  prefsGlobalHelp: 'Suppresses the bell badge, every desktop toast, and background push to your devices. Notifications still arrive and appear in the panel so you can clear them later. Your preferences follow you across workspaces.',
  prefsSectionTypes: 'Types',
  prefsColType: 'Type',
  prefsColMute: 'Mute',
  prefsColDesktop: 'Desktop',
  prefsMuteTypeLabel: 'Mute {{label}}',
  prefsDesktopTypeLabel: 'Desktop toast for {{label}}',
  prefsTypesHelpMute: 'Mute',
  prefsTypesHelpMuteRest: ' hides the row from the badge count and stops its background push (it still appears in the panel). ',
  prefsTypesHelpDesktop: 'Desktop',
  prefsTypesHelpDesktopRest: ' controls the OS-level toast, in this tab and as background push (no effect when mute is on or permission isn’t granted).',
  prefsSectionQuietHours: 'Quiet hours',
  prefsEnableQuietHours: 'Enable quiet hours',
  prefsQuietStart: 'Start',
  prefsQuietEnd: 'End',
  prefsQuietTz: 'Times are in your timezone ({{tz}}).',
  prefsQuietDays: 'Days',
  prefsAllowUrgent: 'Allow urgent during quiet hours',
  prefsQuietHelpStart: 'Crosses midnight when end < start (e.g., 22:00 → 08:00). During the window, desktop toasts and background push are suppressed unless the row’s priority is ',
  prefsQuietHelpUrgentToken: 'urgent',
  prefsQuietHelpEnd: ' and this toggle is on.',
  dayShortSun: 'Sun',
  dayShortMon: 'Mon',
  dayShortTue: 'Tue',
  dayShortWed: 'Wed',
  dayShortThu: 'Thu',
  dayShortFri: 'Fri',
  dayShortSat: 'Sat',

  // ─── Notification type labels (TYPE_LABEL_KEYS) ─────────────────────
  typeApprovalNeeded: 'Approval needed',
  typeInputNeeded: 'Input needed',
  typeWorkflowFailed: 'Workflow failed',
  typeWorkflowCompleted: 'Workflow completed',
  typeSystemAlert: 'System alert',
  typeChannelActivity: 'Channel activity',
  typeCommentAdded: 'New comment',
  typeCommentReply: 'New reply',
  typeCommentMention: 'Mention',
  typeCommentResolved: 'Comment resolved',
  typeReviewRequested: 'Review requested',
  typeReviewDecided: 'Review decided',

  // ─── ApprovalsInbox ─────────────────────────────────────────────────
  approveLabel: 'Approve',
  approvalsClaudeCodeGroup: 'Claude Code permission',
  approvalsClaudeCodeAsk: 'Claude Code on {{device}} wants to use {{tool}}.',
  approvalsClaudeCodeAllow: 'Allow',
  approvalsClaudeCodeDeny: 'Deny',
  rejectLabel: 'Reject',
  editDraftLabel: 'Edit draft',
  riskChip: 'risk: {{level}}',
  derivedFromUntrusted: 'derived from connected (untrusted) content',
  editedAt: 'edited {{when}}',
  recipientsPrefix: 'Recipients: ',
  recipientsEmpty: '—',
  whyPrefix: 'Why: {{reason}}',
  sourcesPrefix: 'Sources: ',
  saveEdit: 'Save edit',
  edit: 'Edit',
  approveAndRun: 'Approve & run',
  approvalsColAgent: 'Agent',
  approvalsColProposes: 'Proposes to',
  approvalsRunWorkflow: 'Run <1>{{name}}</1>',
  approvalsOnCard: 'on “{{title}}”',
  approvalsColProposed: 'Proposed',
  approvalsEmpty: 'Nothing awaiting sign-off — no pages submitted for review, and no agent proposals. Submit a CMS page for review, or set an agent’s autonomy to review (on its Roster card), to route work here.',
  approvalsTitle: 'Awaiting sign-off',
  approvalsPending: '{{count}} pending',
  approvalsLede: 'Everything waiting on your decision: pages submitted for editorial review, and proposals your agents drafted but won’t act on without you. Approving a page publishes it; approving a run starts it; approving a drafted action carries it out. Nothing happens until you approve it.',
  approvalsLoadFailedTitle: 'We couldn’t load your approvals',
  approvalsRetry: 'Retry',
  approvalsTableCaption: 'Pending agent run proposals awaiting human sign-off',
  toastApprovedCarry: 'Approved — {{persona}} is sending it now. We\'ll tell you if it fails.',
  toastApprovedRunning: 'Approved — {{persona}} is running it now.',
  toastApprovedPublished: 'Approved — the page is now published.',
  inboxLoadFailedBody: 'Your notifications couldn’t be loaded — they most likely still exist. Try again.',
  inboxActionFailedBody: 'That didn’t go through. Try again.',
  needsYouLoadFailed: 'Approvals couldn’t be checked right now — there may be items waiting that aren’t shown.',
  interruptLoadFailed: 'This approval couldn’t be loaded. Try again from the run page.',
  approvalsOtherGroup: 'Awaiting your approval',
  toastApprovedGeneric: 'Approved.',
  bellLabelStale: 'Notifications — live updates interrupted, reconnecting',
  arrivalAnnounce_one: '{{count}} unread notification',
  arrivalAnnounce_other: '{{count}} unread notifications',
  staleConnectionNotice: 'Live updates are interrupted — reconnecting. What you see may be out of date; it refreshes automatically when the connection returns.',
  approvalsContentGroup: 'Content awaiting publish approval',
  approvalsSpendGroup: 'Ad-spend approvals',
  approvalsCommerceSpendGroup: 'Agent-purchase approvals',
  toastApprovedSpend: 'Approved. Open the purchase to place it — nothing is bought until you do.',
  approvalsStrategyGroup: 'Strategy activation approvals',
  strategySnapshotLabel: "What you are approving",
  strategySnapshotHorizon: "Horizon: {{horizon}}",
  strategySnapshotExecutive: "Accountable: {{name}}",
  strategySnapshotNoObjectives: "No objectives yet.",
  strategySnapshotTarget: "target {{target}} {{unit}}",
  strategySnapshotSource: "measured from {{kind}}",
  strategySnapshotOpen: "Open strategy",
  strategySnapshotLegacy: "No content preview for this request; review the strategy before approving.",
  toastApprovedActivated: 'Approved — the strategy is now active.',
  // SGU-1 — on-screen provenance for a decided strategy-activation gate.
  approvalsStrategyDecidedGroup: 'Recently decided',
  approvalsDecidedApproved: 'Approved',
  approvalsDecidedRejected: 'Rejected',
  approvalsDecidedByUnknown: 'a workspace member',
  approvedByOn: 'Approved by {{name}} on {{date}}',
  rejectedByOn: 'Rejected by {{name}} on {{date}}',
  approvedOn: 'Approved on {{date}}',
  rejectedOn: 'Rejected on {{date}}',
  approvalsScenarioGroup: 'Priority-scenario approvals',
  toastApprovedScenario: 'Approved — the scenario is now the plan of record.',
  toastCouldNotClaim: 'Could not claim the proposal.',
  toastProposalDismissed: 'Proposal dismissed.',
  toastCouldNotReject: 'Could not reject the proposal.',
  toastDraftUpdated: 'Draft updated — it will face you again for approval.',
  toastEditFailed: 'Edit failed.',

  // ─── NeedsYouInbox ──────────────────────────────────────────────────
  relativeNow: 'now',
  viewModeLabel: 'View mode',
  viewModeList: 'List',
  viewModeGrid: 'Grid',
  needsYouAllClear: 'You’re all caught up — nothing needs your sign-off or a board action right now.',
  needsYouFromUntrusted: 'from connected (untrusted) content',
  needsYouTitle: 'Needs you',
  needsYouLede: 'Pages submitted for review, proposals to approve, drafted actions, and board blockers — everything waiting on a decision, in one place.',
  blockerDefaultTitle: 'A task is parked in the Waiting lane',
  blockerDefaultNote: 'Waiting on your review before this can move forward — open the board to act.',
  blockerWaitingWorkflow: 'Waiting on your review before {{workflow}} can continue.',
  openBoard: 'Open board',
  toastDismissed: 'Dismissed.',
  toastCouldNotApprove: 'Could not approve.',
  toastCouldNotRejectShort: 'Could not reject.',

  // ─── NotificationsPage ──────────────────────────────────────────────
  tabActionNeeded: 'Action needed',
  tabPageAll: 'All',
  tabPageArchived: 'Archived',
  pageEyebrow: 'Inbox',
  pageTitle: 'Inbox',
  pageLede: 'Your agents’ communication portal — everything that needs you in one place: proposals to approve, drafted actions, board blockers, and workflow interrupts (resolved inline).',
  filterAriaLabel: 'Filter inbox by queue',
  urgentOnly: 'Urgent & high ({{count}})',
  urgentOnlyActive: 'Showing {{count}} of {{total}}',
  loadingInbox: 'Loading inbox…',
  emptyArchivedTitle: 'Nothing archived yet',
  emptyArchivedBody: 'Notifications you dismiss with Archive land here — nothing’s been archived so far.',
  backToActionNeeded: 'Back to Action needed',
  emptyActionNeededTitle: 'No approvals or input requests',
  emptyActionNeededBody: "You're all clear. Workflows suspended on a human-in-the-loop interrupt show up here when they need you.",
  viewRuns: 'View runs →',
  emptyAllTitle: 'No notifications yet',
  emptyAllBody: 'Run a workflow and its events will surface here as they happen.',
  browseWorkflows: 'Browse workflows →',
  priorityUrgent: 'Urgent',
  priorityHigh: 'High',
  priorityLow: 'Low',
  cardUnread: 'Unread',
  cardRunLink: 'run {{id}} →',
  archive: 'Archive',
  delete: 'Delete',
  interruptResolvedElsewhere: 'Interrupt may have been resolved elsewhere — refresh to reconcile.',

  // ─── pushSubscription (developer-facing errors stay code; none user-facing) ──

  // ─── approval delegation (ADR 0198) ───
  delegationHeading: 'Approval delegation',
  delegationLede: 'Going out of office? Delegate your approvals — your delegate can sign off wherever you could, and their decision counts as yours (never as a second vote).',
  delegationEmpty: 'No active delegations.',
  delegationToLabel: 'Delegate to',
  delegationToPlaceholder: 'Choose a person…',
  delegationFromDate: 'From',
  delegationToDate: 'Until',
  delegationReasonLabel: 'Reason (optional)',
  delegationReasonPlaceholder: 'e.g. PTO',
  delegationCreateCta: 'Delegate my approvals',
  delegationCreated: 'Delegation created.',
  delegationCreateFailed: 'Could not create the delegation.',
  delegationRevoke: 'Revoke',
  delegationRevoked: 'Delegation revoked.',
  delegationRevokeFailed: 'Could not revoke the delegation.',

  // ─── Teams approval delivery (ADR 0198 Phase B) ───
  teamsDeliveryHeading: 'Teams delivery',
  teamsDeliveryLede: 'Get your approval requests as a card in Microsoft Teams, with a link back here to decide. Deciding always happens in OpenWOP.',
  teamsDeliveryActive: 'Delivering to Teams',
  teamsDeliveryConnection: 'Microsoft 365 connection',
  teamsDeliveryChoose: 'Choose a connection…',
  teamsDeliveryChatId: 'Teams chat id',
  teamsDeliveryChatPlaceholder: 'e.g. 19:abc123@thread.v2',
  teamsDeliverySave: 'Save',
  teamsDeliverySaved: 'Teams delivery enabled.',
  teamsDeliverySaveFailed: 'Could not save Teams delivery.',
  teamsDeliveryDisable: 'Turn off',
  teamsDeliveryDisabled: 'Teams delivery turned off.',
  teamsDeliveryDisableFailed: 'Could not turn off Teams delivery.',
  emailApprovalHeading: 'Email me approval requests',
  emailApprovalBody: 'When an approval names you, also send it to this address — with one-click approve/reject links for workflow gates. Requires the host to have email sending configured.',
  emailApprovalPlaceholder: 'you@example.com',
  emailApprovalEnable: 'Enabled',
  emailApprovalSaved: 'Saved.',
  emailApprovalLoading: 'Loading…',
  emailApprovalLoadFailed: 'Couldn\'t load your email preference. Saving now could overwrite the stored address.',
  emailApprovalLoadRetry: 'Retry',
  emailApprovalSaveFailed: 'Couldn\'t save the email preference. Check the address and try again.',
  emailApprovalSave: 'Save',
  emailApprovalOwnership: 'Decision links will be sent to this address — make sure it is yours. Address verification is coming; until then, treat this like a password reset address.',

  // ── ADR 0593 D3/D4 — the CMS editorial review card ──
  approvalsOpenPage: 'Open “{{title}}”',
  approvalsPinnedVersion: 'reviewing v{{version}}',
  approvalsAiDrafted_one: '{{count}} AI-drafted locale: {{locales}}',
  approvalsAiDrafted_other: '{{count}} AI-drafted locales: {{locales}}',
  approvalsAiDraftedTitle: 'These translations were drafted by a model and have not been reviewed by a person.',
  approvalsLiveData_one: '{{count}} live-data section, not frozen by approval',
  approvalsLiveData_other: '{{count}} live-data sections, not frozen by approval',
  approvalsOutdatedTranslations_one: '{{count}} translation is outdated ({{locales}}), review it in the editor',
  approvalsOutdatedTranslations_other: '{{count}} translations are outdated ({{locales}}), review them in the editor',
  rejectReasonLabel: 'Why are you sending this back?',
  rejectReasonPlaceholder: 'The editor sees this on the page. Optional, but a rejection with no reason is a dead end.',
  rejectSendLabel: 'Send back to draft',
  rejectCancelLabel: 'Cancel',
  toastRejectedToDraft: 'Rejected — the page is back in draft.',
  toastStrategyRejectedToDraft: 'Rejected — the strategy is back in draft and can be resubmitted.',
  approvalStaleReview: 'This page changed after it was submitted. Open it, read the current version, then submit it for review again.',
  approvalUnpinnedReview: 'This review could not say which version it was about. It has been pinned to the current one — re-read the page and decide again.',
  approvalClosedPageDeleted: 'This review was closed automatically: the page no longer exists.',
  approvalClosedNotInReview: 'This review was closed automatically: the page is now {{status}} and is no longer under review.',
  approvalForbidden: 'You don’t have permission to decide this.',
  approvalGone: 'This item is no longer available.',
  approvalAlreadyDecided: 'Someone already decided this one.',
  approvalAgentPaused: 'This agent is paused. Resume it, then approve again — the proposal is still waiting.',
  approvalStrategyChanged: "This strategy changed after it was submitted, so the review was closed. It needs submitting again.",
  approvalSelfApproval: "You submitted this, so another approver has to decide it.",
  // ADR 0905 D3 — email campaign send review
  approvalsEmailSendGroup: 'Email campaigns awaiting send approval',
  toastApprovedEmailSend: 'Approved — the campaign can now be sent.',
  toastEmailRejectedToDraft: 'Changes requested — the campaign is back in draft.',
  emailReviewVersion: 'Template v{{version}}',
  emailReviewFrom: 'From {{sender}}',
  emailReviewAudience: 'To {{audience}}',
  emailReviewEstimate_one: 'About {{n}} recipient (estimate)',
  emailReviewEstimate_other: 'About {{n}} recipients (estimate)',
  approvalEmailStale: 'This campaign changed after it was submitted. Ask the submitter to submit it for review again.',
  approvalEmailClosed: 'This review was closed automatically: the campaign is no longer under this review.',
  approvalsCreativeReviewGroup: "AI creative to review before publishing",
  approvalsCreativeReviewHelp: "The brand-accuracy check asked for a person. Approving lets this exact version be published; any new check needs a new review.",
  approvalsCreativeReviewUnavailable: "The asset and check could not be verified. Retry, or request a new review if they changed.",
  toastApprovedCreativeReview: "Approved. This version can now be published.",
  approvalsFunnelPublishGroup: "Funnel publish approvals",
  approvalsFunnelPublishHelp: "Approving publishes this funnel and makes its offers available for purchase. Its step pages must already be published.",
  approvalsFunnelPublishApprove: "Approve & publish",
  toastApprovedFunnelPublish: "Approved — the funnel is now published.",
} as const;
